import React from 'react';
import moment from 'moment';

import { isEmpty, isObject } from 'lodash';
import { func, shape } from 'prop-types';
import { languages } from './options';
import { testTypes } from '../../../../constants/options';

import {
  AmountContainer,
  Amount,
  Button,
  CenterContainer,
  Container,
  Content,
  CloseIcon,
  Devices,
  Device,
  TextPrimary,
  QuestionCounter,
  ResponsiveContainer,
  InfoContainer,
} from './styles';

import { hasBooking, getBooking, isRemoved } from '../../helpers';

import ModeratedStudy from '../moderated-study';

const StudyCard = (props) => {
  const {
    testerStudy,
    onButtonClick,
    onStudyRejected,
  } = props;

  const {
    device,
    operatingSystem,
    testType,
    sessionDuration,
    participantsLanguage,
    testers,
    surveys,
  } = testerStudy;

  const [tester] = testers || [];
  const { testSessions = [] } = tester || {};

  const [{ text: language }] = languages.filter(({ value }) => value === participantsLanguage);
  const hasScreener = !isEmpty(surveys);
  const booking = hasBooking(testSessions);
  const removed = isRemoved(tester);
  const hasTestSession = !isEmpty(testSessions);
  const isModerated = testType === 'moderated';
  const isQualified = tester && tester.status === 'qualified';

  const dismissCard = async () => {
    onStudyRejected(testerStudy);
  };

  if (removed) {
    return null;
  }

  const renderActionButton = () => {
    if (isModerated) {
      if (booking) {
        const [{
          startAt,
          timeZone,
          endAt,
          id: testSessionId,
        }] = getBooking(testSessions);

        const formattedDate = moment(startAt).format('LL');
        const intermediateMeetingPagePath = `/moderated-meeting?test-session=${testSessionId}`;

        return (
          <ModeratedStudy
            date={formattedDate}
            time={startAt}
            timezone={timeZone}
            device={device}
            startAt={startAt}
            endAt={endAt}
            intermediateMeetingPagePath={intermediateMeetingPagePath}
          />
        );
      }
      if (hasTestSession) {
        return (
          <Button onClick={() => onButtonClick(testerStudy, false)}>
            Schedule Time
          </Button>
        );
      }
      if (hasScreener) {
        const [survey] = surveys;
        const surveyText = `${survey.questions.length} question`;
        return (
          <>
            <Button onClick={() => onButtonClick(testerStudy)}>
              Take Screener Survey
            </Button>
            {survey.questions.length > 0 && (
              <QuestionCounter>
                {survey.questions.length > 1 ? `${surveyText}s` : surveyText}
              </QuestionCounter>
            )}
          </>
        );
      }
      return (
        <Button onClick={() => onButtonClick(testerStudy, false)}>
          Schedule Time
        </Button>
      );
    }
    if (hasScreener && !isQualified) {
      const [survey] = surveys;
      const surveyText = `${survey.questions.length} question`;
      return (
        <>
          <Button onClick={() => onButtonClick(testerStudy)}>
            Take Screener Survey
          </Button>
          {survey.questions.length > 0 && (
            <QuestionCounter>
              {survey.questions.length > 1 ? `${surveyText}s` : surveyText}
            </QuestionCounter>
          )}
        </>
      );
    }
    return (
      <Button onClick={() => onButtonClick(testerStudy)}>
        Take Study
      </Button>
    );
  };

  return (
    <Container>
      {!booking && (
        <CloseIcon onClick={dismissCard} />
      )}
      <Content>
        <AmountContainer>
          <Amount>
            $
            {isObject(testTypes[testType].amount) ? testTypes[testType].amount[sessionDuration] : testTypes[testType].amount}
          </Amount>
        </AmountContainer>
        <ResponsiveContainer>
          <CenterContainer>
            <Devices>
              <Device device={device} os={operatingSystem} />
            </Devices>
            <TextPrimary>{testTypes[testType].label}</TextPrimary>
          </CenterContainer>

          <InfoContainer>
            <TextPrimary>
              Test Language:
              {' '}
              {language}
            </TextPrimary>

            {(testerStudy.faceRecording && testerStudy.device === 'computer') && (
              <TextPrimary>
                Face recording
              </TextPrimary>
            )}
          </InfoContainer>
        </ResponsiveContainer>
      </Content>

      {renderActionButton()}
    </Container>
  );
};

StudyCard.propTypes = {
  testerStudy: shape().isRequired,
  onButtonClick: func.isRequired,
  onStudyRejected: func.isRequired,
};

export default StudyCard;
